// extracted by mini-css-extract-plugin
export default {"mapBox":"SectionMap_mapBox__ODPdF"};